/* Copyright (c) 2017 Backpack Health LLC */

/* global IS_ANDROID_BUILD */

import React from 'react';

import { TextLink, ExternalLink } from './TextLink';
import { FormattedMessage } from 'react-intl';

interface LegalDocumentLinkProps {
  className?: string;
  style?: object;
  onClick?(): void;
  urlMessageId: string;
  children: any;
}

class LegalDocumentLink extends React.Component<LegalDocumentLinkProps, {}> {
  render() {
    const { className, style, onClick, urlMessageId, children } = this.props;

    return (
      <FormattedMessage id={urlMessageId}>
        {
          (url) => (
            <ExternalLink href={url} onClick={onClick} className={className} style={style}>
              {children}
            </ExternalLink>
          )
        }
      </FormattedMessage>
    );
  }
}

class LegalDocumentWebViewLink extends React.Component<LegalDocumentLinkProps, {}> {
  render() {
    const { className, style, urlMessageId, onClick, children } = this.props;
    return (
      <FormattedMessage id={urlMessageId}>
        {
          (url) => (
            <TextLink
              className={className}
              style={style}
              onClick={() => {
                cordova.InAppBrowser.open(url, '_blank', 'location=yes');
                if (onClick) { onClick(); }
              }}
            >
              {children}
            </TextLink>
          )
        }
      </FormattedMessage>
    );
  }
}

const LegalDocumentLinks =  IS_ANDROID_BUILD ? {
  PrivacyPolicy: (props) => <LegalDocumentWebViewLink {...props} urlMessageId="legal.privacyPolicy.URL" />,
  TermsOfService: (props) => <LegalDocumentWebViewLink {...props} urlMessageId="legal.termsOfService.URL" />,
  GroupConsent: (props) => <LegalDocumentWebViewLink {...props} urlMessageId="legal.groupConsent.URL" />,
  CookiePolicy: (props) => <LegalDocumentWebViewLink {...props} urlMessageId="legal.cookiePolicy.URL" />,
  Acknowledgements: (props) => <LegalDocumentWebViewLink {...props} urlMessageId="legal.acknowledgements.URL" />,
  InformedConsent: (props) => <LegalDocumentWebViewLink {...props} urlMessageId="legal.informedConsent.URL" />,
  Resources: (props) => <LegalDocumentWebViewLink {...props} urlMessageId="appMenu.resources.URL" />,
  NewWindowLink: (props) => <LegalDocumentWebViewLink {...props} />,
} : {
  PrivacyPolicy: (props) => <LegalDocumentLink {...props} urlMessageId="legal.privacyPolicy.URL" />,
  TermsOfService: (props) => <LegalDocumentLink {...props} urlMessageId="legal.termsOfService.URL" />,
  GroupConsent: (props) => <LegalDocumentLink {...props} urlMessageId="legal.groupConsent.URL" />,
  CookiePolicy: (props) => <LegalDocumentLink {...props} urlMessageId="legal.cookiePolicy.URL" />,
  Acknowledgements: (props) => <LegalDocumentLink {...props} urlMessageId="legal.acknowledgements.URL" />,
  InformedConsent: (props) => <LegalDocumentLink {...props} urlMessageId="legal.informedConsent.URL" />,
  Resources: (props) => <LegalDocumentLink {...props} urlMessageId="appMenu.resources.URL" />,
  NewWindowLink: (props) => <LegalDocumentLink {...props} />,
};

export default LegalDocumentLinks;
